import type { StufenBeschreibung } from '@luzula/luzula-lib';
import { grauTreppe } from './stufen-farbtreppe';

/**
 * Konsistenz von Mudden und Quellsedimenten (K1–K5), Spalte „Konsistenz" im
 * Moorprotokoll. Der Eingabewert ist die Ziffer des Kurzzeichens (1 … 5).
 *
 * Die Reihe liegt hier, weil zwei Stellen sie brauchen: der Hilfetext am (i)
 * (`muddeKonsistenzHilfetext`) und das Stufen-Feld in der Substratfolge
 * (`MUDDE_KONSISTENZ_STUFEN_FELD`). Vorher stand der Text nur im Hilfedienst.
 */
export interface MuddeKonsistenzStufe {
	wert: number;
	code: string;
	name: string;
	ansprache: string;
}

export const MUDDE_KONSISTENZ_STUFEN: MuddeKonsistenzStufe[] = [
	{ wert: 1, code: 'K1', name: 'flüssig', ansprache: 'meist dickflüssig, z.T. auch sülzig mit Fließeigenschaften' },
	{ wert: 2, code: 'K2', name: 'breiig', ansprache: 'Substrat quillt bei geringstem Druck aus der geschlossenen Hand' },
	{ wert: 3, code: 'K3', name: 'sehr weich', ansprache: 'Substrat ist leicht zwischen den Fingern durchpressbar' },
	{ wert: 4, code: 'K4', name: 'weich', ansprache: 'Substrat leicht knetbar' },
	{ wert: 5, code: 'K5', name: 'steif', ansprache: 'Substrat schwer knetbar' },
];

/** Der Hilfetext am (i) — wortgleich mit dem bisherigen Text im Hilfedienst. */
export function muddeKonsistenzHilfetext(): string {
	const zeilen = MUDDE_KONSISTENZ_STUFEN.map(s => `${s.code} — ${s.name} (${s.ansprache})`);
	return 'Konsistenz von Mudden und Quellsedimenten (K1–K5)\n\n' + zeilen.join('\n');
}

/** Für das Stufen-Feld: keine eigene Legende, deshalb die graue Treppe. */
export const MUDDE_KONSISTENZ_STUFEN_FELD: StufenBeschreibung[] = (() => {
	const farben = grauTreppe(MUDDE_KONSISTENZ_STUFEN.length);
	return MUDDE_KONSISTENZ_STUFEN.map((s, i) => ({ wert: s.wert, farbe: farben[i], name: s.name }));
})();
